export const QUERY_CMS_WEBFLOW_PARTNERS = "QUERY_CMS_WEBFLOW_PARTNERS";
export const QUERY_CMS_WEBFLOW_PARTNER = "QUERY_CMS_WEBFLOW_PARTNER";
export const QUERY_CMS_WEBFLOW_BENEFITS = "QUERY_CMS_WEBFLOW_BENEFITS";
export const QUERY_CMS_WEBFLOW_BENEFIT = "QUERY_CMS_WEBFLOW_BENEFIT";
export const QUERY_CMS_WEBFLOW_ENTERPRISE = "QUERY_CMS_WEBFLOW_ENTERPRISE";
export const QUERY_CMS_WEBFLOW_ENTERPRISES = "QUERY_CMS_WEBFLOW_ENTERPRISES";
